import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchPost } from '../../fetch/fetchConfig'
import { QUERY_GET_USER_DATA, QUERY_POST_LOGIN} from '../../fetch/constantQueries'
import { baseThunk, getUrl } from '../../fetch/basicThunk';

export const postLogin = createAsyncThunk(
    'authentication/login',
    async (userinfo, thunkApi) => {
          const response = await fetch( getUrl() + QUERY_POST_LOGIN, fetchPost(userinfo));
          if (!response.ok){
                  const error = await response.json()
                  throw error.result};
      const data = response.json()
          return data
    }
  )

  export const getUserData = baseThunk("getUserData", QUERY_GET_USER_DATA, "GET")
